import en from '../../../i18n/en';
import tw from '../../../i18n/tw';
import cn from '../../../i18n/cn';
import vi from '../../../i18n/vi';
import ja from '../../../i18n/ja';

class Language {

    constructor() {

        this.language = null;
        this.languageData = null;
        this.languageType = 'en';

    }

    static getInstance(){
        if(this.language==null){
            this.language = new Language();
        }
        return this.language;
    }


    setLanguage(language){
        // language = 'vi';
        console.log('language', language);     
        this.languageType = language;   
        this.languageData = en;
        if(language=='en'){
            this.languageData = en;
        }else if(language=='tw'){
            this.languageData = tw;
        }else if(language=='cn'){
            this.languageData = cn;
        }else if(language=='vi'){
            this.languageData = vi;
        }else if(language=='ja'){
            this.languageData = ja;
        }
    }

    getLanguageType(){
        return this.languageType;
    }

    getLanguage(key){
        return this.languageData[key];
    }

    getMedicinePath(){     
        var path = '/res/medicine/'
        if(this.languageType=='en'){
            path = '/res/medicine/en/'
        }else if(this.languageType=='tw'){
            path = '/res/medicine/zh/'
        }else if(this.languageType=='cn'){
            path = '/res/medicine/cn/'
        }else if(this.languageType=='vi'){
            path = '/res/medicine/vi/'
        }else if(this.languageType=='ja'){
            path = '/res/medicine/ja/'
        }

        return path;
        
    }

    getElementPath(){     
        var path = '/res/elements/'
        if(this.languageType=='en'){
            path = '/res/elements/en/'
        }else if(this.languageType=='tw'){
            path = '/res/elements/zh/'
        }else if(this.languageType=='cn'){
            path = '/res/elements/cn/'
        }else if(this.languageType=='vi'){
            path = '/res/elements/vi/'
        }else if(this.languageType=='ja'){
            path = '/res/elements/ja/'
        }

        return path;
        
    }

    getPokerPath(){     
        var path = '/res/poker/'
        if(this.languageType=='en'){
            path = '/res/poker/en/'
        }else if(this.languageType=='tw'){
            path = '/res/poker/zh/'
        }else if(this.languageType=='cn'){
            path = '/res/poker/cn/'
        }else if(this.languageType=='vi'){
            path = '/res/poker/vi/'
        }else if(this.languageType=='ja'){
            path = '/res/poker/ja/'
        }

        return path;
        
    }

    getColorViLangSize(){
        var vi_lang_size = '60px';

		if(this.languageType=='vi'){
			vi_lang_size = '40px';
		}

        console.log('vi_lang_size', vi_lang_size);

        return vi_lang_size;
    }
}

export default Language